import BaseResource from './BaseResource';
import { objectToUrlParams } from 'utils/params';

export default class ArtworkResource extends BaseResource {
  constructor() {
    super({ url: '/api/users' });
  }

  current(params = { includes: 'organisation' }) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}/current${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  update(data) {
    return super
      .patch(data, { url: `${this.url}/current` })
      .then((response) => response)
      .catch((error) => error.response);
  }
}
